var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParthnerRelationship(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Relationship",
    transform: "translate(8863 -9503)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_600",
    "data-name": "Ellipse 600",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(-8863 9503)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_11_-_20",
    "data-name": "11 - 20",
    transform: "translate(-8836.79 9549.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Relationship-2",
    "data-name": "Relationship",
    transform: "translate(-0.733 9.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19391",
    "data-name": "Path 19391",
    d: "M60.524,59.441l-.5-.419a7.219,7.219,0,0,0-10.148.887l2.406-2.884a7.219,7.219,0,0,0-.887-10.148l-.5-.419a7.219,7.219,0,0,0-10.148.887c.179-.213.361-.4.54-.612l1.874-2.269a7.154,7.154,0,0,0-.9-10.118l-.505-.433a7.154,7.154,0,0,0-10.118.9l-2.451,2.881a7.219,7.219,0,0,0-.863-10.155l-.505-.433a7.2,7.2,0,0,0-10.155.9l-8.8,10.5a4.894,4.894,0,0,0-.4.54,7.2,7.2,0,0,0,1.262,9.626l.5.433a7.219,7.219,0,0,0,10.159-.9,7.219,7.219,0,0,0,.9,10.152l.505.4a7.189,7.189,0,0,0,10.121-.863l.021-.024a7.2,7.2,0,0,0,.887,10.145l.5.423a7.219,7.219,0,0,0,10.148-.89,7.219,7.219,0,0,0,.887,10.148l.5.423A7.219,7.219,0,0,0,55,77.225l6.412-7.642A7.219,7.219,0,0,0,60.524,59.441Z",
    transform: "translate(19.985 29.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19392",
    "data-name": "Path 19392",
    d: "M73.443,18.975a13.672,13.672,0,0,1-1.348-3.438A26.471,26.471,0,0,0,63.243,14H51.361a26.65,26.65,0,0,0-14.188,4.084l-16.086,10.1a6.821,6.821,0,0,0,6.188,12.1l31.1-12.376L90.69,55.515c.688-.526,1.6-1.293,2.6-2.176Z",
    transform: "translate(46.103 1.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1936",
    "data-name": "Rectangle 1936",
    width: 22.322,
    height: 57.312,
    rx: 2,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 122.058, 11.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1937",
    "data-name": "Rectangle 1937",
    width: 57.312,
    height: 22.322,
    rx: 2,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 49.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19393",
    "data-name": "Path 19393",
    d: "M103.706,77.489l1.774,1.65a7.64,7.64,0,1,0,9.97-11.579L83.416,39.975,80.865,37.8,53.641,48.632a13.7,13.7,0,0,1-12.417-24.3l14.253-8.938L39.563,13.407A30.15,30.15,0,0,0,30,13.786a13.617,13.617,0,0,1-1.8,7.171L8.117,55.734l1.973-2.355a14.1,14.1,0,0,1,19.833-1.757l.564.481a13.917,13.917,0,0,1,2.75,3.135,14.026,14.026,0,0,1,10.657,3.214l.55.471a13.9,13.9,0,0,1,4.923,9.512c0,.124.021.244.028.364A14.1,14.1,0,0,1,53.008,71l.5.419a14.03,14.03,0,0,1,5,9.942,13.937,13.937,0,0,1,3.62,2.2l.512.43a13.975,13.975,0,0,1,2.173,19.169l1.554,1.416A7.532,7.532,0,1,0,76.513,93.454l2.406,2.2A7.53,7.53,0,1,0,89.078,84.536l4.469,4.074a7.532,7.532,0,1,0,10.159-11.122Z",
    transform: "translate(22.306 -0.391)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParthnerRelationship);
export default __webpack_public_path__ + "static/media/parthner-Relationship.9a955d6a54ebb83dc8b87f97dd7b1a49.svg";
export { ForwardRef as ReactComponent };